module.exports = {
  urlInfo:{
    queryUrl:'http://webadmin.goodfoodchina.net'
  }
}